export const environment = {
    production:false,
    outdoorNetUrl:'https://#{{OutdoorURL}}#'
};
